import { InjectionToken } from '@angular/core';
import { TranslateConfig } from '@/core/util/translate.config';

export const TRANSLATE_CONFIG_TOKEN = new InjectionToken<TranslateConfig>('TRANSLATE_CONFIG_TOKEN');
